import moment from 'moment';
import { DATE_FORMAT ,DATE_TIME_FORMAT} from '../../../../constants';
export function showETA(param) {
    let ETA = moment(param).format(DATE_FORMAT);
    return ETA;
}

export function showEDTA(param) {
    let ETA = moment(param).format(DATE_TIME_FORMAT);
    return ETA;
}

export function hasETACrossed(dueDateStr) {
    let dueDate = moment(dueDateStr);
    let currentDate = moment();
    let diffDays = dueDate.diff(currentDate, 'days');
    if (diffDays < 3) {
        return true;
    }
    else
        return false;
}
export function caseColumns() {
    let columns = [{
        "header": "Title",
        "accessor": "title"
    }, {
        "header": "Value",
        "accessor": "value"
    }]
    return columns
}

export const getStatusColor = (status) => {
    if (status === 'PENDING') {
        return 'text-truncate text-warning'
    } else if (status === 'PROCESSING') {
        return 'text-truncate status-color'
    } else if (status === 'FAILURE') {
        return 'text-truncate text-danger'
    } else {
        return 'text-truncate text-success'
    }
}

export const copyArray = (data) => {
    let tempLevelOne = JSON.stringify(data);
    return JSON.parse(tempLevelOne)
}